import React from "react";

function InterviewImpression({
  ratingCategories,
  currentRatingCategory,
  styles,
}) {
  console.warn(currentRatingCategory);
  return (
    <div
      style={{
        display: "flex",
        padding: "1rem",
        flexDirection: "column",
        marginLeft: "-8px",
        marginRight: "-8px",
        gap: "1rem",
      }}
    >
      <div
        style={{
          flex: "0 0 16.6667%",
          // maxWidth: "16.6667%",
          paddingLeft: "8px",
          paddingRight: "8px",
          fontWeight: "bold",
          fontSize: styles.content.fontSize,
        }}
      >
        Overall Impression
      </div>

      <div style={{ display: "flex" }}>
        {ratingCategories.map((category, index) => {
          const isActive =
            currentRatingCategory &&
            currentRatingCategory.label === category.label;

          console.warn("active", isActive);
          return (
            <div
              key={index}
              style={{
                flex: "0 0 16.6667%",
                // maxWidth: "16.6667%",
                width: "100%",
                paddingLeft: "8px",
                paddingRight: "8px",
              }}
            >
              <div
                style={{
                  fontSize: styles.content.fontSize,
                  fontWeight: 600,
                  color: isActive ? "#E09552" : "inherit",
                  transition: "color 0.3s ease",
                  width: "100%",
                }}
              >
                {category.label}
              </div>
              <div
                style={{
                  fontSize: styles.content.fontSize,
                  color: isActive ? "#E09552" : "#6c757d",
                  transition: "color 0.3s ease",
                  width: "100%",
                }}
              >
                {category.range[0]}-{category.range[1]} points
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default InterviewImpression;
